import React from 'react';
import { Route, useHistory } from 'react-router-dom';
import ScreenLayout from '../screen/ScreenLayout';
import { NavigationRoute } from '../../../api/Navigation';
import { useAuth0 } from '@auth0/auth0-react';
import { DEFAULT_AUTH0_REDIRECT_PATH } from '../../../api/constants';

export type RouteWrapperProps = NavigationRoute;

const Auth0UnauthenticatedRoute: React.FC<RouteWrapperProps> = (props) => {
  const { isAuthenticated, isLoading } = useAuth0();
  const history = useHistory();

  if (isLoading) {
    return null;
  }

  if (isAuthenticated && !isLoading) {
    history.replace(DEFAULT_AUTH0_REDIRECT_PATH);
    return null;
  }

  return (
    <Route
      path={props.path as string}
      render={() => {
        return (
          <ScreenLayout header={props.header}>
            <props.component />
          </ScreenLayout>
        );
      }}
    />
  );
};

export default Auth0UnauthenticatedRoute;
